import { Link } from 'react-router-dom';
import { ReactNode } from 'react';

interface LayoutProps {
  children: ReactNode;
}

export function Layout({ children }: LayoutProps) {
  return (
    <div className="min-h-screen bg-shadow-800 font-body">
      <header className="bg-shadow-700 shadow-dark border-b border-stone-800">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            <Link to="/" className="flex items-center space-x-3 group">
              <svg
                className="w-8 h-8 text-gold-400 group-hover:text-gold-300 transition-colors"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M9 20l-5.447-2.724A1 1 0 013 16.382V5.618a1 1 0 011.447-.894L9 7m0 13l6-3m-6 3V7m6 10l4.553 2.276A1 1 0 0021 18.382V7.618a1 1 0 00-.553-.894L15 4m0 13V4m0 0L9 7"
                />
              </svg>
              <span className="text-2xl font-display font-bold text-stone-100 group-hover:text-gold-300 transition-colors tracking-wide">
                Gimme Dat Map
              </span>
            </Link>
            <nav className="flex space-x-8">
              <Link
                to="/"
                className="text-stone-300 hover:text-gold-300 font-medium transition-colors tracking-wide text-lg"
              >
                Home
              </Link>
              <Link
                to="/maps"
                className="text-stone-300 hover:text-gold-300 font-medium transition-colors tracking-wide text-lg"
              >
                Browse
              </Link>
              <a
                href="https://dysonlogos.blog/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-stone-300 hover:text-gold-300 font-medium transition-colors tracking-wide text-lg"
              >
                Dyson Logos
              </a>
            </nav>
          </div>
        </div>
      </header>

      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {children}
      </main>

      <footer className="bg-shadow-700 border-t border-stone-800 mt-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <p className="text-center text-stone-400 text-base">
            Maps by{' '}
            <a
              href="https://dysonlogos.blog/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-gold-400 hover:text-gold-300 font-medium transition-colors"
            >
              Dyson Logos
            </a>
            {' '}•{' '}
            Archive for personal use only
          </p>
        </div>
      </footer>
    </div>
  );
}
